import { createFileRoute } from "@tanstack/react-router";
import { PeopleScreen } from "../screens/PeopleScreen";

export const Route = createFileRoute("/people")({
  component: PeopleScreen,
});
